import { exists } from '@/helpers/utilities';

let Intersection = (() => {
    class Intersection {
        constructor(node) {
            this.node = node;
            this.nodeExists = exists(this.node);

            this.options = {
                root: null,
                threshold: this.buildThresholdList(),
            };

            this.hasAnimated = false;
            this.entryEvent = new CustomEvent('enteredView');
            this.revealAfter = this.node.dataset.revealAfter;
        }

        checkFinished(observer) {
            if (!this.hasAnimated) return;

            //disconnect IntersectionObserver instance when done animating
            observer.unobserve(this.node);
        }

        handleVisibilty(entries) {
            this.checkFinished(this.visibiltyHandler);

            entries.map((entry) => {
                let visibility = Math.round(entry.intersectionRatio * 100);
                let threshold = this.revealAfter ? parseInt(this.revealAfter) : 5;

                /* check boundingClient rect to determine if element is already above 
                the top of the viewport: in case a user refreshes further down the page */
                if (visibility > threshold || entry.boundingClientRect.top < 0) {
                    this.hasAnimated = true;
                    this.node.dispatchEvent(this.entryEvent);
                    this.node.classList.add('js-is-active'); 
                }
            });
        }

        buildThresholdList() {
            //"steps" sets level of precision for IntersectionObserver
            //more steps to check = more intervals of intersection to loop over
            let steps = 50;
            let thresholds = Array.from({ length: steps });

            let calculated_thresholds = thresholds.map((item, index) => {
                return (index + 1) / thresholds.length;
            });

            return calculated_thresholds;
        }

        createObservers() {
            if (this.node.hasAttribute(`data-reveal`)) {
                this.visibiltyHandler = new IntersectionObserver(this.handleVisibilty.bind(this), this.options);
                this.visibiltyHandler.observe(this.node);
            }
        }

        addReadyClass() {
            this.node.classList.add(`js-is-ready`);
        }

        shouldInit() {
            let supports = 'IntersectionObserver' in window;
            let safeConditions = [supports, this.nodeExists];

            return safeConditions.every((truthy) => truthy);
        }

        init() {
            if (!this.shouldInit()) return;
            this.createObservers();
            this.addReadyClass();
        }
    }

    return {
        init({ selector }) {
            let nodeList = document.querySelectorAll(selector);

            if (!nodeList.length) return;

            return [...nodeList].map((node) => {
                let module = new Intersection(node);
                module.init();

                return module;
            });
        },
    };
})();

export default Object.create(Intersection);
